/** @jsxImportSource @emotion/react */
import { css} from '@emotion/react'
import { useEffect, useRef, useState} from 'react'
import { Form, Input, Radio, Select, Spin} from 'antd'

import axios from './apiClient'
import moment from 'moment/moment';
import { Backdrop, Box, ButtonBase, Fade, IconButton, Modal } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import config from './config';
import { io } from 'socket.io-client';

const boxStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'white',
  borderRadius: "1rem",
  boxShadow: 24,
  p: 4,
};


export default function ListOdds() {
    const [matches,setMatches] = useState([]);
    const [segmentMatches,setSegmentMatches] = useState([]);
    const [form] = Form.useForm();
    const [matchLang,setMatchLang] = useState("my");
    const [period, setPeriod] = useState("all");
    const [betType, setBetType] = useState("all");
    const [fontSize,setFontSize] = useState(16)
    const [loading,setLoading] = useState(false);
    const [openModel, setOpenModel] = useState(false);
    const myContent = useRef();
    const mounted = useRef(false);
    const totalVh = useRef();
    const currentVh = useRef(0);
    const intervalId = useRef();
    const getMatchesIntervalId = useRef();
    const intervalRun = useRef(true);
    const [height,setHeight] = useState(100);
    const socketRef = useRef();

    const matchCount = useRef(10);
    const totalSegments = useRef(0);
    const segmentCount = useRef(0);

    useEffect(()=>{
      mounted.current = true;
      const defaultSetting = JSON.parse(localStorage.getItem("defaultSetting"));
      const fontSize = defaultSetting?.fontSize;
      const matchLang = defaultSetting?.matchLang;
      const period = defaultSetting?.period;
      const betType = defaultSetting?.betType;
      const storedMatchCount = defaultSetting?.matchCount;
      if(storedMatchCount) matchCount.current = storedMatchCount;
      if (matchLang && (matchLang == "my" || matchLang == "eng")) setMatchLang(matchLang)
      if (period) setPeriod(period);
      if (betType) setBetType(betType);
      if (fontSize ) setFontSize(fontSize)
      getMatches();
      
      // Start the 30-second interval for getMatches
      startGetMatchesInterval();

      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get('token');
      socketRef.current = io(config.socketApi, {
        auth: {
          token: token
        },

      });
      socketRef.current.io.on("error", (error) => {
        // console.log("error from socket",error)
      });

      socketRef.current.on('oddUpdated', oddUpdated);

      // socketRef.current.on('matchUpdated',matchUpdated);


      return () => {
        socketRef.current.off('oddUpdated');
        // socketRef.current.off('matchUpdated');
        socketRef.current.disconnect();
        
        // Clear the getMatches interval
        if (getMatchesIntervalId.current) {
          clearInterval(getMatchesIntervalId.current);
        }
        
        const idsString = localStorage.getItem('timeoutIds')
        if (idsString) {
          let idsArrays = JSON.parse(idsString);
          idsArrays.forEach(id => {
            clearTimeout(id);
          });
          localStorage.setItem('timeoutIds', JSON.stringify([]));
        }
      };
    },[])


    useEffect(()=>{
      // setTimeout(() => {
      //   const contentHeightInVh = (myContent.current?.scrollHeight / window.innerHeight) ;
      //   totalVh.current = Math.ceil(contentHeightInVh)
      //   setHeight(()=>{
      //       return Math.ceil(contentHeightInVh) * 100
      //   })
      // }, 1000);
    },[])

    const getMatches = async ()=> {
      const res = await axios.get(`/bet/getBettingByTV`);
      if(res.code != 200) return;
      // let arr = res.data;
      // for (let index = 0; index < 5; index++) {
      //   res.data.forEach(v=> arr.push(v))
        
      // }

      // Filter out expired matches first
      const now = new Date();
      // Add 40 minutes for testing
      //ow.setMinutes(now.getMinutes() + 40);
      let filteredMatches = res.data.filter(match => {
        const matchDate = new Date(match.matchDate);
        return matchDate >= now;
      });
      
      // Filter matches by period
      const defaultSetting = JSON.parse(localStorage.getItem("defaultSetting"));
      const p = defaultSetting?.period;
      if (p && p !== "all") {
        console.log("period filter applied: ", p);
        filteredMatches = filteredMatches.filter(match => match.odd.periods === p);
      }
      const b = defaultSetting?.betType;
      if (b && b !== "all") {
        console.log("bet filter applied: ", b);
        filteredMatches = filteredMatches.filter(match => match.odd.type === b || match.odd.type === "all");
      }
      const remainder = filteredMatches.length % matchCount.current;
      if(remainder == 0) {
        totalSegments.current = filteredMatches.length / (matchCount.current *2 );
      }else{
        totalSegments.current = Math.floor( filteredMatches.length /  (matchCount.current * 2) ) + 1;
      }
      console.log("filteredMatches : ",filteredMatches);
      setMatches(filteredMatches);
      
      // Set initial segment matches
      const initialSegment = 1;
      segmentCount.current = initialSegment;
      const slicedMatches = filteredMatches.slice(
        (initialSegment - 1) * matchCount.current * 2,
        matchCount.current * initialSegment * 2
      );
      setSegmentMatches(slicedMatches);
    }

    const handleModelClose = () => {
      intervalRun.current = true;
      setOpenModel(false);
      
      // Restart the getMatches interval when modal closes
      startGetMatchesInterval();
    };

    const handleModelOpen = () => {
      clearInterval(intervalId.current)
      intervalId.current = null;
      intervalRun.current = false;
      
      // Stop the getMatches interval when modal opens
      if (getMatchesIntervalId.current) {
        clearInterval(getMatchesIntervalId.current);
        getMatchesIntervalId.current = null;
      }
      
      setOpenModel(true)
    };

    const settingOnFinish = async (values) => {
      const {fontSize,lang,matchCount, period, betType} = values;
      const defaultSetting = {fontSize,matchLang: lang,matchCount, period, betType}
      localStorage.setItem('defaultSetting',JSON.stringify(defaultSetting));
      intervalRun.current = true;
      setOpenModel(false);
      window.location.reload(false);
    };
     







    const startGetMatchesInterval = () => {
      // Clear any existing interval
      if (getMatchesIntervalId.current) {
        clearInterval(getMatchesIntervalId.current);
      }
      
      // Start new interval to call getMatches every 30 seconds
      getMatchesIntervalId.current = setInterval(() => {
        getMatches();
      }, 30000); // 30 seconds = 30000 milliseconds
    }

    // const oddUpdated = (data) => {
    //   // window.location.reload(false);
    //   const socketData = data;
    //   console.log("socketData : ",socketData);
      
    //   return
    //   let localData = [];
    //   let a = []; //changed local data without "change" params

    //   setMatches((preState)=>{
    //       localData = [...preState];
    //       console.log("localData : ",localData);
    //       if(localData.length == 0) return localData;
    //       for (let i = 0; i < socketData.length; i++) {
    //           const socketMatch = socketData[i];
    //           const {matchId: remoteMatchId,hdp: remoteHdp,ou: remoteOu,periods: remotePeriod} = socketMatch;
    //           for (let y = 0; y < localData.length; y++) { // loop the matches
    //               const {matchId :localMatchId,odd: localOdd} = localData[y];
    //               if(localMatchId != remoteMatchId) continue;
    //               if(localOdd.periods != remotePeriod) continue;
    //               const copylocalOdd = JSON.parse(JSON.stringify(localOdd));
    //               localOdd.hdp = remoteHdp;
    //               localOdd.ou  = remoteOu;
    //               a = JSON.parse(JSON.stringify(localData));
    //               if(remoteHdp.converted == copylocalOdd?.hdp?.converted && remoteOu.converted == copylocalOdd?.ou?.converted) continue;
    //               if(remoteHdp.converted != copylocalOdd?.hdp?.converted) remoteHdp.change = true;
    //               if(remoteOu.converted != copylocalOdd?.ou?.converted) remoteOu.change = true;   
    //           }  
              
    //           const timeoutId = setTimeout(()=>{
    //               setMatches((preState)=> {
    //                   const matches = [...preState];
    //                   for (let y = 0; y < matches.length; y++) { // loop the matches
    //                       const match = matches[y];
    //                       const odd = match.odd;
    //                       if(odd.hdp.change) odd.hdp.change = false;
    //                       if(odd.ou.change) odd.ou.change = false;
    //                   }                           
    //                   return matches
    //               })
    //           },5000)
    //           let idsString = localStorage.getItem('timeoutIds')
    //           if(!idsString) idsString = JSON.stringify([]);
    //           let idsArrays = JSON.parse(idsString);
    //           idsArrays.push(timeoutId);
    //           localStorage.setItem('timeoutIds',JSON.stringify(idsArrays));
    //       }
    //       return localData
    //   })

    // }

    // ...existing code...
    const oddUpdated = (socketData) => {
      setMatches((prevMatches) => {
        const updatedMatches = prevMatches.map((match) => {
          const socketMatch = socketData.find(
            (sm) =>
              sm.matchId === match.matchId &&
              sm.periods === match.odd.periods
          );
          if (!socketMatch) return match;

          const newOdd = { ...match.odd };
          let hdpChanged = socketMatch.hdp.converted !== newOdd.hdp.converted;
          let ouChanged = socketMatch.ou.converted !== newOdd.ou.converted;

          newOdd.hdp = { ...socketMatch.hdp, change: hdpChanged };
          newOdd.ou = { ...socketMatch.ou, change: ouChanged };

          return {
            ...match,
            odd: newOdd,
          };
        });

        // Also update segmentMatches
        setSegmentMatches((prevSegmentMatches) =>
          prevSegmentMatches.map((match) => {
            const socketMatch = socketData.find(
              (sm) =>
                sm.matchId === match.matchId &&
                sm.periods === match.odd.periods
            );
            if (!socketMatch) return match;

            const newOdd = { ...match.odd };
            let hdpChanged = socketMatch.hdp.converted !== newOdd.hdp.converted;
            let ouChanged = socketMatch.ou.converted !== newOdd.ou.converted;

            newOdd.hdp = { ...socketMatch.hdp, change: hdpChanged };
            newOdd.ou = { ...socketMatch.ou, change: ouChanged };

            return {
              ...match,
              odd: newOdd,
            };
          })
        );

        // Remove change flag after 5 seconds
        if (socketData.length > 0) {
          const timeoutId = setTimeout(() => {
            setMatches((matches) =>
              matches.map((match) => ({
                ...match,
                odd: {
                  ...match.odd,
                  hdp: { ...match.odd.hdp, change: false },
                  ou: { ...match.odd.ou, change: false },
                },
              }))
            );
            setSegmentMatches((segmentMatches) =>
              segmentMatches.map((match) => ({
                ...match,
                odd: {
                  ...match.odd,
                  hdp: { ...match.odd.hdp, change: false },
                  ou: { ...match.odd.ou, change: false },
                },
              }))
            );
          }, 5000);

          let idsString = localStorage.getItem('timeoutIds');
          if (!idsString) idsString = JSON.stringify([]);
          let idsArrays = JSON.parse(idsString);
          idsArrays.push(timeoutId);
          localStorage.setItem('timeoutIds', JSON.stringify(idsArrays));
        }

        return updatedMatches;
      });
    };


    
  // const matchUpdated = (data) => {
  //   const socketData = JSON.parse(data)?.match;
  //   setMatches((preState)=>{
  //     const matches = [...preState];
  //     let returnData = [];
  //     outerLoop : for(let i=0;i<matches.length;++i){
  //       const localMatch = matches[i];
  //       for (let z = 0; z < socketData.length; z++) {
  //         const socketMatch = socketData[z];
  //         if(localMatch.matchId == socketMatch.matchId && socketMatch.status == "2H"){
  //           continue outerLoop;
  //         }else if(localMatch.matchId == socketMatch.matchId && socketMatch.status == "1H" && (localMatch.selectedPeriods == "full_time" || localMatch.selectedPeriods == "first_time")){
  //           continue outerLoop;
  //         }
  //       }
  //       returnData.push(localMatch);
  //     }

  //     return returnData;
  //   })

  // }


    
    const defaultSetting = {
      matchLang,
      fontSize,
      matchCount: matchCount.current,
      period,
      betType
    }

    let periodText ;

    if(period == 'full_time') periodText = "FT"
    if(period == 'first_time') periodText = "1H"
    if(period == 'second_time') periodText = "2H"

    let betTypeText ;

    if(betType == 'single') betTypeText = "ဘော်ဒီ"
    if(betType == 'mix_parlay') betTypeText = "မောင်း"

    return (
      <div ref={myContent} >
        <div 
        style={{
          backgroundColor: '#252424',
          minHeight: `${height}vh`
        }}
        > 
          <Spin spinning={loading}>
              <Setting openModel={openModel} handleModelClose={handleModelClose} settingOnFinish={settingOnFinish} defaultSetting={defaultSetting}/>
              <div style={{display: "flex",justifyContent: 'space-between',marginRight: "2rem"}}>
                <div style={{display: 'flex',alignItems: 'center',marginLeft: '1rem'}}>
                  <span style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    marginRight: '1rem'
                  }}>
                    <span style={{
                      display: 'inline-block',
                      width: 16,
                      height: 16,
                      borderRadius: '50%',
                      background: '#2bff34',
                      marginRight: 6,
                      border: '1px solid gray'
                    }}></span>
                    <span style={{color: 'white', fontSize: 14}}>ဘော်ဒီ</span>
                  </span>
                  <span style={{
                    display: 'inline-flex',
                    alignItems: 'center'
                  }}>
                    <span style={{
                      display: 'inline-block',
                      width: 16,
                      height: 16,
                      borderRadius: '50%',
                      background: 'orange',
                      marginRight: 6,
                      border: '1px solid gray'
                    }}></span>
                    <span style={{color: 'white', fontSize: 14}}>ဂိုးပေါင်း</span>
                  </span>
                  <span style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    marginRight: '1rem',
                    marginLeft: "1rem"
                  }}>
                    <span style={{
                      display: 'inline-block',
                      width: 16,
                      height: 16,
                      borderRadius: '50%',
                      background: '#252424',
                      marginRight: 6,
                      border: '1px solid gray'
                    }}></span>
                    <span style={{color: 'white', fontSize: 14}}>ပွဲကြီး</span>
                  </span>
                  <span style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    marginRight: '1rem',
                    marginLeft: "1rem"
                  }}>
                    <span style={{
                      display: 'inline-block',
                      width: 16,
                      height: 16,
                      borderRadius: '50%',
                      background: '#353535',
                      marginRight: 6,
                      border: '0.5px solid gray'
                    }}></span>
                    <span style={{color: 'white', fontSize: 14}}>ပွဲသေး</span>
                  </span>
                  {betType !== "all" && <span style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    marginRight: '1rem',
                    marginLeft: "1rem",
                    // background: '#408E91', // Highlight background for selected
                    borderRadius: '1rem',
                    padding: '0 0.5rem',
                    paddingTop: "2px"
                  }}>
                    <span style={{
                      color: 'red',
                      fontSize: 14,
                      fontWeight: 'bold', // Make text bold for selected
                      letterSpacing: 1
                    }}>{betTypeText}</span>
                  </span>}
                </div>
                <IconButton >
                    <SettingsIcon style={{color: "white"}} onClick={() => handleModelOpen()}/>
                </IconButton>
              </div>
              {/* <div style={{display: 'flex'}}>
                <div style={{flexBasis: "50%",alignItems: 'center',borderStyle: "solid",borderWidth: "0 1px 0 0",borderColor: "darkgray"}}>
                  {
                    matches.map((match,index)=> {
                      const isEven = (index + 1) % 2 == 0 ;
                      if(!isEven) return <MatchRow match={match} lang={matchLang} fontSize={fontSize}/>
                    })
                  }
                </div>
                <div style={{flexBasis: "50%",alignItems: 'center'}}>
                  {
                    matches.map((match,index)=> {
                      const isEven = (index + 1) % 2 == 0 ;
                      if(isEven) return <MatchRow match={match} lang={matchLang} fontSize={fontSize}/>
                    })
                  }
                </div>
              </div> */}
               <div style={{display: 'flex'}}>
                <div style={{flexBasis: "50%",alignItems: 'center',borderStyle: "solid",borderWidth: "0 1px 0 0",borderColor: "darkgray"}}>
                  {
                    segmentMatches.map((match,index)=> {
                      const satisfied = index < matchCount.current;
                      if(satisfied) return <MatchRow key={index} match={match} lang={matchLang} fontSize={fontSize} matchId={match?.matchId}/>
                    })
                  }
                </div>
                <div style={{flexBasis: "50%",alignItems: 'center'}}>
                  {
                    segmentMatches.map((match,index)=> {
                      const satisfied = index >= matchCount.current;
                      if(satisfied) return <MatchRow key={index} match={match} lang={matchLang} fontSize={fontSize} matchId={match?.matchId}/>
                    })
                  }
                </div>
              </div>
              {mounted.current && !loading && matches.length === 0 && 
                <div style={{display: 'flex',justifyContent: 'center',alignItems: 'center',height: '80vh'}}>
                  <h2 style={{color: 'gray'}}>No Match Found {period !== 'all' && "For " + periodText}</h2>
                </div>
              }
               
            </Spin>
        </div>
      </div>
    )
}


const MatchRow = ({match,lang,fontSize, matchId}) => {
      let size = fontSize;

      let fontFamily;
      if(lang == "my"){
        fontFamily = 'myanmar'
      }else{
        fontFamily = 'sans-serif'
      }

      let {matchDate, homeTeam, awayTeam, odd, big} = match;
      const bigMatch = match?.big == '1' ? true : false;
      let rowBg ;
      if(odd.hdp.change || odd.ou.change){
        rowBg = '#564848';
      }else{
        if(bigMatch){
          rowBg = ''
        }else{
          rowBg = '#353535';
        }
      }

      

      let periodText ;
      const periods = odd.periods;
      if(periods == 'full_time') periodText = "FT*"
      if(periods == 'first_time') periodText = "1H*"
      if(periods == 'second_time') periodText = "2H*"
      const homeTeamHasHandicap = odd.hdp.home_team_has_hadicap;
      const hdp = `(${odd.hdp.converted})`;
      const ou = `(${odd.ou.converted})`
      const homeTeamName = lang == 'my' ? homeTeam?.name_mm : homeTeam?.name_en;
      const awayTeamName = lang == 'my' ? awayTeam?.name_mm : awayTeam?.name_en;
      const a = `${periodText} ${homeTeamName}`
      const b = `${periodText} ${awayTeamName}`
      matchDate = moment(matchDate).format("hh:mm A")

     return (
      <div style={{backgroundColor: rowBg,display: "flex",justifyContent: "space-around",borderStyle: "solid",borderColor: "dimgrey",borderWidth: "0 0 0.5px 0",padding: "1rem 0",height: '30px'}}>
          <div  style={{width: "15%"}}>
            <h3 style={{fontSize: `${size}px`,color: 'white',margin: 0, color: "skyblue"}}>{matchDate}</h3>
          </div>
          <div  style={{width: "30%"}}>
            <h3 style={{fontSize: `${size}px`,color: 'white',fontFamily: fontFamily,margin: 0}}>{a}<span style={{color: "#2bff34",fontFamily: 'sans-serif',fontSize: `${size}px`}}> {homeTeamHasHandicap && hdp}</span></h3>
          </div>
          <div  style={{width: "15%"}}>
            <h3 style={{fontSize: `${size}px`,color: 'orange',margin: 0}}>{ou}</h3>
          </div>
          <div  style={{width: "30%"}}>
            <h3 style={{fontSize: `${size}px`,color: 'white',fontFamily: fontFamily,margin: 0}}>{b}<span style={{color: "#2bff34",fontFamily: 'sans-serif',fontSize: `${size}px`}}> {!homeTeamHasHandicap  && hdp}</span></h3>
          </div>
        
      </div>
     )
}


const Setting = ({openModel,handleModelClose,settingOnFinish,defaultSetting}) => {
  const itemCount = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50]
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={openModel}
      onClose={handleModelClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={openModel} >
        <Box sx={boxStyle} css={css`padding: 1.4rem 32px;`}>
          <div css={css`font-family: cursive;margin-top: 1.4rem;display: flex;justify-content: center;align-items: center;font-size: 1.125rem;`}>
            Setting
          </div>
          <Form
            name="basic"
            className="modal-points"
            style={{
              marginTop: "2rem",
              fontFamily: "inherit",
            }}
            initialValues={{
              remember: true,
            }}
            onFinish={settingOnFinish}
            autoComplete="off"
          >
             <Form.Item
              css={css`
              flex-basis: 50%;
            `}
              label="Language"
              name = "lang"
              labelCol={{ span: 5 }}
              wrapperCol={{ span: 17 }}
              style={{ padding: "0 0.4rem", color: "white" }}
              initialValue={defaultSetting.matchLang}
            >
              <Radio.Group style={{marginLeft: '2rem'}}>
                <Radio value={'eng'}>English</Radio>
                <Radio value={'my'}>Myanmar</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              css={css`
              flex-basis: 50%;
            `}
              label="Period"
              name = "period"
              labelCol={{ span: 5 }}
              wrapperCol={{ span: 17 }}
              style={{ padding: "0 0.4rem", color: "white" }}
              initialValue={defaultSetting.period}
            >
              <Radio.Group style={{marginLeft: '2rem'}}>
                <Radio value={'all'}>All</Radio>
                <Radio value={'full_time'}>FT</Radio>
                <Radio value={'first_time'}>1H</Radio>
                <Radio value={'second_time'}>2H</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              css={css`
              flex-basis: 50%;
            `}
              label="Bet Type"
              name = "betType"
              labelCol={{ span: 5 }}
              wrapperCol={{ span: 17 }}
              style={{ padding: "0 0.4rem", color: "white" }}
              initialValue={defaultSetting.betType}
            >
              <Radio.Group style={{marginLeft: '2rem'}}>
                <Radio value={'all'}>All</Radio>
                <Radio value={'single'}>Single</Radio>
                <Radio value={'mix_parlay'}>Parlay</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              css={css`
              flex-basis: 50%;
            `}
              label="Rows"
              labelCol={{ span: 5 }}
              wrapperCol={{ span: 17 }}
              name="matchCount"
              style={{ padding: "0 0.4rem", color: "white" }}
              initialValue={defaultSetting.matchCount}
            >
              <Select
                css={css`margin-left: 2rem;`}
                dropdownStyle={{ zIndex: 2000 }}
                size='large'
                options={itemCount.map(g=>{
                  let value = g;
                  if(g == "=") value = 0;
                  return {value: value,label: g}
                })}
              />
            </Form.Item>

            <Form.Item
              css={css`
              flex-basis: 50%;
            `}
              label="Font Size"
              labelCol={{ span: 5 }}
              wrapperCol={{ span: 17 }}
              name="fontSize"
              style={{ padding: "0 0.4rem", color: "white" }}
              initialValue={defaultSetting.fontSize}
            >
              {/* <Select
                css={css`margin-left: 2rem;`}
                dropdownStyle={{ zIndex: 2000 }}
                size='large'
                options={[{label: "small",value: 'small'},{label: "medium",value: 'medium'},{label: "large",value: 'large'},{label: "extra large",value: 'extraLarge'},{label: "ultra large",value: 'ultraLarge'}]}
              /> */}
               <Input type='number' 
                  css={css`margin-left: 2rem;`}
                  onKeyDown={(e)=> {
                    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
                    }
                    } 
                  size="large" placeholder="px" 
                />
            </Form.Item>


           
           

            <div
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
                padding: "0.6rem 0 0 0",
                marginTop: "1rem",
              }}
            >
              <ButtonBase
                component="button"
                onClick={() => handleModelClose()}
                style={{
                  color: "black",
                  display: "flex",
                  backgroundColor: "#D27685",
                  padding: "0.6rem 1.8rem",
                  borderRadius: "2rem",
                  justifyContent: "center",
                  alignItems: "center",
                  marginRight: "1rem"
                }}
              >
                <h4 style={{ textAlign: "center", margin: 0 }}>Cancel</h4>
              </ButtonBase>
              <ButtonBase
                type="submit"
                component="button"
                style={{
                  color: "black",
                  display: "flex",
                  backgroundColor: "#408E91",
                  padding: "0.6rem 1.8rem",
                  borderRadius: "2rem",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <h4 style={{ textAlign: "center", margin: 0 }}>Save</h4>
              </ButtonBase>

            </div>
          </Form>
        </Box>
      </Fade>
    </Modal>
  )
}

